class ProductDrawer extends HTMLElement {
  constructor() {
    super();

    this.content = this.querySelector('[data-product-drawer-content]');
    document.addEventListener('click', this.handleTriggerClick.bind(this));

    this.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.close();
    });

    this.querySelector('.product-drawer')?.addEventListener('click', (event) => {
      if (event.target === event.currentTarget) {
        this.close();
      }
    });
  }

  async handleTriggerClick(event) {
    const trigger = event.target.closest('[data-product-drawer-trigger]');
    if (!trigger) return;

    event.preventDefault();

    const handle = trigger.dataset.productHandle;
    if (!handle) return;

    const enableAtb = trigger.dataset?.enableAtb === 'true';
    const enableLongVersion = trigger.dataset?.enableLongVersion === 'true';

    await this.open(handle, enableAtb, enableLongVersion);
  }

  async open(handle, enableAtb, enableLongVersion) {
    this.classList.add('active');
    document.body.classList.add('overflow-hidden');

    this.content.innerHTML = `
      <div class="product-drawer__loading">
        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    `;

    try {
      const response = await fetch(`/products/${handle}?section_id=product-quick-view`);
      const html = await response.text();

      this.content.innerHTML = html;

      this.content.querySelectorAll('[data-quickview-atb]').forEach((element) => {
        element.hidden = !enableAtb;
      });

      this.content.querySelectorAll('[data-quickview-long-version]').forEach((element) => {
        element.hidden = !enableLongVersion;
      });

      this.initializeGallery();
      this.initializeYotpo();
      initializeAccordions(this.content);

      const template = this.content.querySelector('.product-drawer-template');
      const title = template?.dataset.productTitle;
      const titleContainer = this.querySelector('[data-product-drawer-title]');

      if (title && titleContainer) titleContainer.textContent = title;
    } catch (error) {
      this.content.innerHTML = '<p style="padding:1.6rem;">Sorry, this product could not be loaded.</p>';
    }
  }

  initializeGallery() {
    this.content.querySelectorAll('[data-product-drawer-gallery]').forEach((gallery) => {

      gallery.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-gallery-thumb]');
        if (!thumb) return;

        const mediaId = thumb.dataset.galleryThumb;

        gallery.querySelectorAll('video').forEach((video) => {
          video.pause();
        });

        gallery.querySelectorAll('[data-gallery-slide]').forEach((slide) => {
          slide.classList.toggle(
            'is-active',
            slide.dataset.gallerySlide === mediaId
          );
        });

        gallery.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
          button.classList.toggle('is-active', button === thumb);
        });
      });

    });
  }

  initializeYotpo() {
    const widgets = this.content.querySelectorAll('.yotpo-widget-instance');

    if (!widgets.length) return;

    setTimeout(() => {
      if (window.yotpoWidgetsContainer?.initWidgets) {
        window.yotpoWidgetsContainer.initWidgets();
      }
      if (window.yotpo?.initWidgets) {
        window.yotpo.initWidgets();
      }
      document.dispatchEvent(new Event('yotpo:load'));
    }, 100);
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('product-drawer', ProductDrawer);